import React from 'react';
import { UserShippingAddress } from '../../interfaces/user.interface';

interface ShippingAddressInfoProps {
  shippingAddress?: UserShippingAddress | undefined;
  numberBookPurchased: number;
  userName: string | undefined;
}

const ShippingAddressInfo: React.FC<ShippingAddressInfoProps> = ({
                                                                   shippingAddress,
                                                                   numberBookPurchased,
                                                                   userName
                                                                 }: ShippingAddressInfoProps) => {
  return (
    <>
      <div className="max-w-md mx-auto px-2 md:px-6 py-6 bg-white">
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-18 8h18a2 2 0 002-2V6a2 2 0 00-2-2H3a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
            </svg>
            <h2 className="text-lg font-semibold">Shipping To</h2>
          </div>
          <div className="text-gray-800">
            <p className="font-semibold">{shippingAddress?.shippingName}</p>
            <p>Attn: {shippingAddress?.recipientName || userName || 'User'}</p>
            <p>{shippingAddress?.shippingAddress1} {shippingAddress?.shippingAddress2}</p>
            <p>{shippingAddress?.shippingCity}, {shippingAddress?.shippingState} {shippingAddress?.shippingZip}</p>
            <p className="text-sm text-gray-500 mt-1">This is the default school address. Please <span
              className="font-semibold">confirm</span> or <span className="font-semibold">update</span> if needed.</p>
          </div>
        </div>
        <div>
          <div className="flex items-center gap-2 mb-2">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 7v10c0 1.1.9 2 2 2h14a2 2 0 002-2V7m-4-4H7a2 2 0 00-2 2v0a2 2 0 002 2h10a2 2 0 002-2v0a2 2 0 00-2-2z"></path>
            </svg>
            <h2 className="text-lg font-semibold">Total Books</h2>
          </div>
          <div className="text-gray-800">
            <p className="font-semibold">{numberBookPurchased} Books Purchased</p>
            <p className="text-sm text-gray-500">These will be packaged and shipped to the school above.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShippingAddressInfo;
